module.exports = __webpack_public_path__ + "img/bed.963ddc39.jpeg";